import * as R from 'ramda'

const imgHigh = require('../../../assets/v2/icon_client_priority_h.png')
const imgMedium = require('../../../assets/v2/icon_client_priority_m.png')
const imgLow = require('../../../assets/v2/icon_client_priority_l.png')

export const displayAccountPriority = (priority: number) => {
  switch (priority) {
    case 1:
      return imgHigh
    case 2:
      return imgMedium
    case 3:
      return imgLow
  }
}

export const accountPriority: {
  [key: number]: string;
} = {
  3: 'Low',
  2: 'Medium',
  1: 'High'
}

export const accountPriorityKeys = R.keys(accountPriority)
export const accountPriorityValues = R.values(accountPriority)
